// extracted by mini-css-extract-plugin
export default {"cupra":"ButtonPrimary_cupra__1pIwO","tyc":"ButtonPrimary_tyc__1MYkw","irvehiculo":"ButtonPrimary_irvehiculo__EiCTP"};